export default __webpack_public_path__ + "static/media/payment_processing.37e701e8.gif";